// import { useTranslation } from "react-i18next";

import HeroVideo from "../../Components/Hero/HeroVideo";
// import SectionDivider from "../../Components/Hero/SectionDivider";

import Hero from "../../Components/Hero/Hero";
import OurServices from "../../Components/Hero/OurServices";
import CareProcess from "../../Components/Hero/CareProcess";
import TeamSection from "../../Components/Hero/TeamSection";
import ManagementDesk from "../../Components/Hero/ManagementDesk";

const Home = () => {
  return (
    <>
      <Hero />
      <HeroVideo />
      <OurServices />
      <CareProcess />
      <ManagementDesk />
      <TeamSection />
    </>
  );
};

export default Home;